import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { SkeletonEmployerCardLoading } from '@restworld/ui-ds';

import { UserSettingsDataView } from './user-settings-data-view';
import { ComponentLayout, ModalEditKey } from '.';
import { useCurrentLocale, useLanguageOptionsList } from './language-change-modal';
import { useEmployerUserContactData, useEmployerUserInformationLoadingState } from '@restworld/feature-authentication';

export const PersonalInformationSection = () => {
  const { t } = useTranslation('user-settings');
  const employerUserInformation = useEmployerUserContactData();
  const loading = useEmployerUserInformationLoadingState();
  const languageOptions = useLanguageOptionsList();
  const currentLocale = useCurrentLocale();
  const currentLanguage = React.useMemo(
    () => languageOptions.find((item) => item.key === currentLocale)?.label || '',
    [currentLocale, languageOptions]
  );

  const placeHolderData = React.useMemo(
    () => [
      {
        label: 'Picture',
        value: '',
        key: 'picture' as ModalEditKey,
      },
      {
        label: t('name_and_surname'),
        value: '',
        isEditable: true,
        key: 'name_and_surname' as ModalEditKey,
      },
      { label: t('organization'), value: '', key: 'organization' as ModalEditKey },
      { label: t('account_permission_level'), key: 'account_permission_level' as ModalEditKey, value: '' },
      {
        label: t('language'),
        key: 'language' as ModalEditKey,
        value: currentLanguage,
        isEditable: true,
      },
    ],
    [currentLanguage, t]
  );
  const accountData = React.useMemo(() => {
    if (employerUserInformation?.user_id) {
      const {
        user: { name, surname },
        organization: { name: organizationName },
        role_rw,
        picture_url,
      } = employerUserInformation;
      placeHolderData.reduce((acc, item) => {
        if (item.key === 'picture') item.value = picture_url;
        if (item.key === 'name_and_surname') item.value = `${name} ${surname || ''}`;
        if (item.key === 'organization') item.value = organizationName;
        if (item.key === 'account_permission_level') item.value = role_rw?.label || t('not_specified');
        return acc;
      }, []);
      return placeHolderData;
    }
    return placeHolderData;
  }, [employerUserInformation, placeHolderData, t]);
  return (
    <ComponentLayout title={t('personal_information_title')}>
      {loading ? <SkeletonEmployerCardLoading /> : <UserSettingsDataView data={accountData} />}
    </ComponentLayout>
  );
};
